// extracted by mini-css-extract-plugin
export default {"badge-button-wrapper":"_3foMv","badgeButtonWrapper":"_3foMv","badge-button":"VUs5j","badgeButton":"VUs5j","badge":"_2D-Np"};